import { createSelector } from '@reduxjs/toolkit';
import { transliterate } from 'transliteration';

import { RootState } from '../../../../../init-store';
import { SELF } from '../../../../shared/constants';
import { selectVisibleParticipantsList, selectWaitingRoomPeers } from '../../selectors';
import { Participant, WaitingRoomPeerState } from '../../types';

export const selectParticipantsSearchQuery = (state: RootState) => state.call.participantsSearch.query;

const filterParticipants = (participants: (Participant | WaitingRoomPeerState)[], query: string) => {
    const preparedQuery = transliterate(query.toLowerCase());
    const queryParts = preparedQuery.trim().split(' ');
    return participants.filter(({ id, displayName }) => {
        if (id === SELF || displayName === undefined) return false;
        const preparedName = transliterate(displayName.toLowerCase());
        return queryParts.every((queryPart) => preparedName.includes(queryPart));
    });
};

const selectFilteredParticipants = createSelector(
    [selectVisibleParticipantsList, selectParticipantsSearchQuery],
    filterParticipants
);

const selectFilteredWaitingRoomPeers = createSelector(
    [selectWaitingRoomPeers, selectParticipantsSearchQuery],
    filterParticipants
);

export const selectParticipantSearchResult = createSelector(
    [selectFilteredParticipants, selectFilteredWaitingRoomPeers, selectParticipantsSearchQuery],
    (filteredParticipants, filteredWaitingRoomPeers, query) => {
        if (query.length === 0) {
            return null;
        }
        return [...filteredParticipants, ...filteredWaitingRoomPeers].sort(({ displayName: a }, { displayName: b }) => {
            if (a === undefined) {
                return 1;
            }
            if (b === undefined) {
                return -1;
            }
            return a.localeCompare(b, undefined, { sensitivity: 'base' });
        });
    }
);
